export const ROUTE_SWITCHING = 'ROUTE_SWITCHING'
// 主页面的三个标签页记录
export const SET_MAIN_LIST_TAB_INDEX = 'SET_MAIN_LIST_TAB_INDEX'

// account
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const RETRIEVE_ACCOUNT = 'RETRIEVE_ACCOUNT'

// auth
// 检查是否已获得认证,若是则设置状态和http认证头
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION'
// 获得认证:设置状态,保存token,设置http认证头
export const OBTAIN_AUTHENTICATION = 'OBTAIN_AUTHENTICATION'
// 清除认证:清除状态,清除token,清除http认证头
export const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION'

// 微信的openid，用于表单的openid填写
export const WECHAT_OPEN_ID = 'WECHAT_OPEN_ID'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js